<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4 mb-3">
        <div class="card2">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-2 text-center">
                <v-lazy-image :src="photo" class="rounded-circle" style="background: white; width: 40px" />
              </div>
              <div class="col-10">
                <p class="text-capitalize text-truncate mb-0" style="font-size: 12px">
                  {{ displayName }}
                </p>
                <p class="mb-0" style="text-align: left; font-size: 11px">Editar mi perfil</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Evitamos v-if dentro de v-for -->
      <template v-if="userRole === 'administrador' || userRole === 'doctor'">
        <div class="row justify-content-center">
          <router-link v-for="(card, index) in cards" :key="index" :to="card.route"
            class="col-6 col-sm-4 col-md-3 col-lg-3 mb-3 text-decoration-none">
            <div class="card2">
              <div class="card-body text-center py-3">
                <i :class="card.icon" class="text-success" style="font-size: 16px"></i>
                <br />
                <a style="font-size: 12px; font-weight: bold;">{{ card.text }}</a>
              </div>
            </div>
          </router-link>
        </div>
      </template>


    </div>


    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          padding: 1rem;
          text-align: center;
        ">
      <button @click="exit()" class="btn btn-primary btn-sm" type="button" style="width: 100%">
        Cerrar sesión
      </button>
    </div>

  </div>
</template>



<script>
/*eslint-disable */

import myMixin from "../mixin.js";
import { activateDarkMode, deactivateDarkMode } from "@/assets/js/dark-mode";


export default {
  name: "Mas",
  data() {
    const { logout } = myMixin();

    let datos = JSON.parse(localStorage.getItem("userData"));

    let photo = "/img/user.svg";


    return {
      userId: datos.userId,
      isMobile: this.$isMobile,
      displayName: datos.displayName,
      tokenAuth: datos.tokenAuth,
      logout: logout,
      modo: "",
      photo: photo,
      allowAccess: false,
      cards: [
        { icon: "fas fa-prescription", text: "Receta", route: "/dashboard/paciente/receta" },
        { icon: "fas fa-microscope", text: "Nuevos Exámenes", route: "/dashboard/pacientes/NuevosExamenes" },
        { icon: "fas fa-file-signature", text: "Cert. Normal", route: "/dashboard/pacientes/certificados-v1" },
        { icon: "fas fa-hospital-alt", text: "Cert. IESS", route: "/dashboard/pacientes/certificados-v2" }
      ],
    };
  },

  activated() {
    if (this.isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }
  },

  computed: {
    userRole() {
      const encryptedRole = localStorage.getItem("aut");
      if (encryptedRole && this.$encryptBackoffice && this.$encryptBackoffice.decrypt) {
        return this.$encryptBackoffice.decrypt(encryptedRole);
      }
      return null;
    },
  },

  methods: {
    setDarkMode() {
      if (this.$store.state.darkMode) {
        localStorage.setItem("skin", "light");
        this.$store.state.darkMode = false;
        this.modo = "día";
        deactivateDarkMode();
        return;
      } else {
        localStorage.setItem("skin", "dark");
        this.$store.state.darkMode = true;
        this.modo = "noche";
        activateDarkMode();
      }
    },
    decryptedRole() {

    },
    exit() {
      this.$eventBus.emit("clearOverlaySidebar", true);
      this.logout(this.tokenAuth);
    },
  },

  mounted() {
    if (this.$store.state.darkMode) {
      this.modo = "noche";
    } else {
      this.modo = "día";
    }
    //this.decryptedRole();
  },
};
</script>

<style scoped></style>
